export const FileQueryKey = {
  GET_FILE_BLOB: 'get-file-blob',
};
